<template>
    
    <div class="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <!-- Sidebar -->
      <HrSidebar :isOpen="isSidebarOpen" />
  
      <!-- Main Content -->
      <main 
        class="flex-1 overflow-x-hidden transition-all duration-300"
        :class="{'ml-64': isSidebarOpen, 'ml-0': !isSidebarOpen}"
      >
        <!-- Navbar -->
       <header 
        class="fixed top-0 z-50 w-full bg-white dark:bg-gray-800 shadow-sm transition-all duration-300"
      >
        <HrTopbar 
          :page-title="currentPageTitle"
          :is-sidebar-open="isSidebarOpen"
          :is-dark-mode="isDarkMode"
          @toggle-sidebar="toggleSidebar"
          @toggle-dark-mode="toggleDarkMode"
        />
      </header>
    <!-- Main HR Contracts Dashboard -->
    <div v-if="!showContractForm" class="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 mt-20 py-6">
      <!-- <h1 class="text-2xl font-bold text-[#035a76] mb-8">HR Contracts Management</h1> -->
      
      <!-- Contract Management Cards -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 ">
        <!-- New Contract Card -->
        <div @click="navigateTo('')" class="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#fae240] cursor-pointer hover:bg-blue-50 transition-colors">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold text-gray-800">New Employment Contract</h3>
              <p class="text-sm text-gray-500 mt-1">Create new employment contracts</p>
            </div>
            <div class="p-3 rounded-full bg-[#fae240]/20">
  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24">
    <path 
      stroke="#fae240" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      stroke-width="2" 
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
    />
  </svg>
</div>

          </div>
          <div class="mt-4 flex items-center text-sm text-[#fae240]/90">
            <span>Create Contract</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
  
        <!-- Contract Renewal Card -->
        <div @click="navigateTo('renewal')" class="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#e8037e] cursor-pointer hover:bg-green-50 transition-colors">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold text-gray-800">Contract Renewal</h3>
              <p class="text-sm text-gray-500 mt-1">Renew existing contracts</p>
            </div>
            <div class="p-3 rounded-full bg-[#e8037e]/20 text-[#e8037e]">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path 
                  stroke="currentColor" 
                  stroke-linecap="round" 
                  stroke-linejoin="round" 
                  stroke-width="2" 
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
                />
              </svg>
            </div>

          </div>
          <div class="mt-4 flex items-center text-sm text-[#e8037e]">
            <span>Manage Renewals</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
  
        <!-- Promotion Card -->
        <div @click="navigateTo('promotion')" class="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#76ba51] cursor-pointer hover:bg-purple-50 transition-colors">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold text-gray-800">Promotion</h3>
              <p class="text-sm text-gray-500 mt-1">Process staff promotions</p>
            </div>
            <div class="p-3 rounded-full bg-[#76ba51]/20 text-[#76ba51]">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path 
                    stroke="currentColor" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    stroke-width="2" 
                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" 
                  />
                </svg>
            </div>

          </div>
          <div class="mt-4 flex items-center text-sm text-[#76ba51]">
            <span>Process Promotion</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
  
        <!-- Termination Card -->
        <div @click="navigateTo('termination')" class="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-500 cursor-pointer hover:bg-red-50 transition-colors">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold text-gray-800">Termination</h3>
              <p class="text-sm text-gray-500 mt-1">Manage contract terminations</p>
            </div>
            <div class="p-3 rounded-full bg-red-100 text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </div>
          </div>
          <div class="mt-4 flex items-center text-sm text-red-600">
            <span>Process Termination</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
  
      <!-- Recent Contracts Table -->
      <div class="mt-12 bg-white shadow-md rounded-lg overflow-hidden">
        <div class="p-4 border-b">
          <h2 class="text-lg font-semibold text-gray-800">Recent Contracts</h2>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Start Date</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">End Date</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="contract in recentContracts" :key="contract.id" class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
                      <span class="text-blue-600 font-medium">{{ getInitials(contract.employee) }}</span>
                    </div>
                    <div class="ml-4">
                      <div class="text-sm font-medium text-gray-900">{{ contract.employee }}</div>
                      <div class="text-sm text-gray-500">{{ contract.employeeId }}</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ contract.type }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm text-gray-900">{{ contract.position }}</div>
                  <div v-if="contract.section" class="text-sm text-gray-500">{{ contract.section }} ({{ contract.class }})</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(contract.startDate) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(contract.endDate) }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span :class="`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClass(contract.status)}`">
                    {{ contract.status }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button @click="viewContract(contract.id)" class="text-blue-600 hover:text-blue-900 mr-3">View</button>
                  <button @click="editContract(contract.id)" class="text-indigo-600 hover:text-indigo-900">Edit</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  
    <!-- Employment Contract Form (shown when showContractForm is true) -->
    <!-- <EmploymentContract
      v-else
      :contractType="activeContractType"
      @back="showContractForm = false"
      @submit="handleContractSubmit"
    /> -->
    <component
    v-else
    :is="activeFormComponent"
    :employeeData="selectedEmployeeData"
    :contractType="activeContractType"
    @back="showContractForm = false"
    @submit="handleFormSubmit"
  />
      </main>
     </div>
  </template>
  
  <script setup>
  import { ref, watch, computed } from 'vue';
  import HrSidebar from '@/components/hr/HrSidebar.vue';
  import HrTopbar from '@/components/hr/HrTopbar.vue';
//   import EmploymentContract from './EmploymentContract.vue';

import EmploymentContract from './EmploymentContract.vue';
import ContractRenewal from './ContractRenewal.vue';
import PromotionForm from './PromotionForm.vue';
import TerminationForm from './TerminationForm.vue';
import { usePermissions } from '@/composables/usePermissions'

const { hasPermission } = usePermissions()

    const currentPageTitle = ref('Contracts Management');

const showContractForm = ref(false);
const activeContractType = ref('');
const selectedEmployeeData = ref(null);
  
//   const showContractForm = ref(false);
//   const activeContractType = ref('');
  const isSidebarOpen = ref(true);
  const isDarkMode = ref(false);

  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value;
  };
  
  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value;
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark');
      localStorage.theme = 'dark';
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.theme = 'light';
    }
  };

  const employees = ref([
  { id: 'EMP001', name: 'Kwame Mensah', position: 'Mathematics Teacher', department: 'Academics', section: 'Secondary', currentClass: 'Form 2', contractEndDate: '2024-06-30' },
  { id: 'EMP002', name: 'Ama Serwaa', position: 'English Tutor', department: 'Academics', section: 'Primary', currentClass: 'Class 4', contractEndDate: '2023-12-31' },
  { id: 'EMP003', name: 'Yaw Boateng', position: 'Administrator', department: 'Administration', contractEndDate: '2023-10-31' }
]);

const activeFormComponent = computed(() => {
  switch(activeContractType.value) {
    case 'contract': return EmploymentContract;
    case 'renewal': return ContractRenewal;
    case 'promotion': return PromotionForm;
    case 'termination': return TerminationForm;
    default: return EmploymentContract;
  }
});

// const navigateTo = (type) => {
//   activeContractType.value = type;
//   showContractForm.value = true;
// };

const handleFormSubmit = (formData) => {
  console.log(`${activeContractType.value} submitted:`, formData);
  showContractForm.value = false;

}
  // Add to recen
  
  // Sample data - replace with API calls in production
  const recentContracts = ref([
    {
      id: 'CT001',
      employee: 'Kwame Mensah',
      employeeId: 'EMP001',
      type: 'Full-Time',
      position: 'Mathematics Teacher',
      section: 'Secondary',
      class: 'Form 2',
      startDate: '2023-01-15',
      endDate: '2024-01-14',
      status: 'Active'
    },
    {
      id: 'CT002',
      employee: 'Ama Serwaa',
      employeeId: 'EMP002',
      type: 'Part-Time',
      position: 'English Tutor',
      section: 'Primary',
      class: 'Class 4',
      startDate: '2023-03-01',
      endDate: '2023-12-31',
      status: 'Pending Renewal'
    },
    {
      id: 'CT003',
      employee: 'Yaw Boateng',
      employeeId: 'EMP003',
      type: 'Contract',
      position: 'Administrator',
      startDate: '2022-11-01',
      endDate: '2023-10-31',
      status: 'Expired'
    }
  ]);
  
  const navigateTo = (type) => {
    activeContractType.value = type;
    showContractForm.value = true;
  };
  
  const viewContract = (id) => {
    // Navigate to view contract
    console.log('View contract:', id);
  };
  
  const editContract = (id) => {
    // Navigate to edit contract
    console.log('Edit contract:', id);
  };
  
  const handleContractSubmit = (contractData) => {
    console.log('Contract submitted:', contractData);
    showContractForm.value = false;
    // Add to recentContracts or update existing
  };
  
  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };
  
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  
  const getStatusClass = (status) => {
    switch(status.toLowerCase()) {
      case 'active': return 'bg-green-100 text-green-800';
      case 'pending renewal': return 'bg-yellow-100 text-yellow-800';
      case 'expired': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };
  </script>
  
  <style scoped>
  /* Add any custom styles here */
  </style>